$(function () {

    const toggleAnimated = container => {
        const isOpen = container.classList.contains('active');

        if (isOpen) {
            container.style.maxHeight = `${container.scrollHeight}px`;
            requestAnimationFrame(() => {
                //container.style.maxHeight = '0px';
                container.classList.remove('active');
            });
        } else {
            container.classList.add('active');
           //container.style.maxHeight = `${container.scrollHeight}px`;

            const input = container.querySelector('input');
            if (input) input.focus();
        }
    };

    document.addEventListener('click', event => {
        // Post comments toggle
        const postTrigger = event.target.closest('.stat-text, .btn-comment');
        console.log(postTrigger);
        if (postTrigger) {
            const whiteBox = postTrigger.closest('.white-box');            
            const comments = whiteBox?.querySelector('.comment-container');
            if (comments) toggleAnimated(comments);
            return;
        }

        const byteTrigger = event.target.closest('.btn-blue');
        if (byteTrigger) {
            const actionBox = byteTrigger.closest('.group-action-btn');
            const whiteBox = actionBox?.nextElementSibling;           
            const comments = whiteBox?.querySelector('.comment-container');
            if (comments) toggleAnimated(comments);
            return;
        }


        // Reply toggle
        const replyBtn = event.target.closest('.reply-btn');
        if (replyBtn) {
            const commentGroup = replyBtn.closest('.comment-group');
            console.log(commentGroup);
            const replyBox = commentGroup?.querySelector('.comment-group.nested');
            console.log(replyBox);
            if (replyBox) toggleAnimated(replyBox);
        }
    });



    document.addEventListener('click', event => {
        // Open New Publication
        const addPublicationBtn = event.target.closest('.publications_head .btn-primary');
        if (addPublicationBtn) {
            const publicationForm = addPublicationBtn
                .closest('.publications_head')
                ?.nextElementSibling;

            if (publicationForm && publicationForm.classList.contains('publications_new')) {
                publicationForm.style.display = 'block';
            }
            return;
        }

        // Close New Publication
        const closePublicationBtn = event.target.closest('.publications_new .btn-close');
        if (closePublicationBtn) {
            const publicationForm = closePublicationBtn.closest('.publications_new');
            if (publicationForm) {
                publicationForm.style.display = 'none';
            }
        }
    });


    document.addEventListener('input', event => {
        const field = event.target.closest('input[data-max-lenght], textarea[data-max-lenght]');
        if (!field) return;
        const maxLength = parseInt(field.dataset.maxLenght, 10);
        if (!maxLength) return;

        // Enforce max length
        if (field.value.length > maxLength) {
            field.value = field.value.slice(0, maxLength);
        }

        // Find indicator (assumes it's the next sibling or nearby)
        const indicator = field.parentElement?.querySelector('.post-length')
            || field.nextElementSibling;

        if (indicator) {
            indicator.textContent = `${field.value.length} / ${maxLength} characters`;
        }
    });

    const selectedUsersMap = new WeakMap();

    document.addEventListener('input', SiteUtils.debounce(async event => {
        const input = event.target.closest('.member-auto-complete');
        if (!input) return;

        const wrapper = input.closest('.member-auto-complete-wrap');
        const list = wrapper.querySelector('.autocomplete-list');

        const endpoint = input.dataset.endpoint;
        const method = (input.dataset.method || 'GET').toUpperCase();
        const isMultiple = input.dataset.multiple === 'true';

        if (!selectedUsersMap.has(input)) {
            selectedUsersMap.set(input, []);
        }

        const selectedUsers = selectedUsersMap.get(input);

        const query = isMultiple
            ? input.value.split(',').pop().trim()
            : input.value.trim();

        if (!endpoint || query.length < 2) {
            list.innerHTML = '';
            list.style.display = 'none';
            return;
        }

        try {
            let users;

            if (method === 'GET') {
                users = await SiteUtils.AjaxService.get(endpoint, { search: query });
            } else {
                users = await SiteUtils.AjaxService.post(endpoint, { search: query });
            }

            if (!Array.isArray(users.users) || users.users.length === 0) {
                list.innerHTML = '';
                list.style.display = 'none';
                return;
            }

            const filtered = isMultiple
                ? users.users.filter(u => !selectedUsers.some(s => s.id === u.id))
                : users.users;

            list.innerHTML = filtered.map(user => `
                <li data-id="${user.id}" data-name="${user.email}">
                    ${user.email}
                </li>
            `).join('');

            list.style.display = filtered.length ? 'block' : 'none';

        } catch (err) {
            console.error('Autocomplete failed', err);
            list.style.display = 'none';
        }

    }, 300));

    // Selection
    document.addEventListener('click', event => {
        const item = event.target.closest('.autocomplete-list li');
        if (!item) return;

        const wrapper = item.closest('.member-auto-complete-wrap');
        const input = wrapper.querySelector('.member-auto-complete');
        const list = wrapper.querySelector('.autocomplete-list');

        const isMultiple = input.dataset.multiple === 'true';

        if (!selectedUsersMap.has(input)) {
            selectedUsersMap.set(input, []);
        }

        let selectedUsers = selectedUsersMap.get(input);

        const user = {
            id: item.dataset.id,
            name: item.dataset.name
        };

        if (isMultiple) {
            if (!selectedUsers.some(u => u.id === user.id)) {
                selectedUsers.push(user);
            }
            input.value = selectedUsers.map(u => u.name).join(', ') + ', ';
        } else {
            selectedUsers = [user];
            selectedUsersMap.set(input, selectedUsers);
            input.value = user.name;
        }

        list.innerHTML = '';
        list.style.display = 'none';
        input.focus();
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', event => {
        if (event.target.closest('.member-auto-complete-wrap')) return;

        document.querySelectorAll('.autocomplete-list').forEach(list => {
            list.style.display = 'none';
        });
    });


    // Password Strength Meter
    const passwordInput = document.getElementById('pass1');
    const confirmInput = document.getElementById('confirmPassword');
    const strengthLabel = document.getElementById('strength-label');
    const bars = document.querySelector('.line-wrap');
    const ruleList = document.getElementById('passwordRules');
    const errorMsg = document.getElementById('error-match');

    const rules = {
        length: val => val.length >= 8,
        lower: val => /[a-z]/.test(val),
        upper: val => /[A-Z]/.test(val),
        number: val => /\d/.test(val)
    };
    if(passwordInput && confirmInput){
        passwordInput.addEventListener('input', validatePassword);
        confirmInput.addEventListener('input', checkMatch);
    }

    function validatePassword() {
        const val = passwordInput.value;
        let passed = 0;
        const totalRules = Object.keys(rules).length;

        Object.keys(rules).forEach(rule => {
            const isValid = rules[rule](val);
            const li = ruleList.querySelector(`[data-rule="${rule}"]`);

            li.classList.toggle('valid', isValid);
            li.classList.toggle('invalid', !isValid);

            if (isValid) passed++;
        });

        // Input error handling
        if (passed === totalRules) {
            passwordInput.classList.remove('error');
            passwordInput.setAttribute('aria-invalid', 'false');
        } else {
            passwordInput.classList.add('error');
            passwordInput.setAttribute('aria-invalid', 'true');
        }

        // Strength meter
        bars.classList.remove('weak-pass', 'medium-pass', 'strong-pass');

        if (passed <= 2) {
            strengthLabel.textContent = 'Weak';
            bars.classList.add('weak-pass');
        } else if (passed === 3) {
            strengthLabel.textContent = 'Medium';
            bars.classList.add('medium-pass');
        } else {
            strengthLabel.textContent = 'Strong';
            bars.classList.add('strong-pass');
        }

        checkMatch();
    }

    function checkMatch() {
        if (!confirmInput.value) return;

        const match = passwordInput.value === confirmInput.value;

        confirmInput.classList.toggle('error', !match);
        confirmInput.setAttribute('aria-invalid', String(!match));
        errorMsg.style.display = match ? 'none' : 'inline';
    }

    // Notification List Toggle
    document.querySelectorAll('.notification-list-wrap').forEach(wrapper => {
        const toggle = wrapper.querySelector('.switch-checkbox input[type="checkbox"]');
        console.log(toggle);
        const list = wrapper.querySelector('.notification-list');

        if (!toggle || !list) return;

        // Initial state
        list.style.display = toggle.checked ? 'block' : 'none';

        toggle.addEventListener('change', () => {
            list.style.display = toggle.checked ? 'block' : 'none';
        });
    });
    
});